import AWS from "aws-sdk";
import api from "src/api/axios";
import { API_URL } from "src/enviroment/enviroment";
AWS.config.update({
  // accessKeyId: AWS_ACCESS_KEY,
  // secretAccessKey: AWS_SECRET_KEY,
  // region: AWS_REGION
  accessKeyId: "AKIAUNBAJ3PZF57PPIUW",
  secretAccessKey: "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",
  region: "us-east-2",
});

const uploadImage = async (formData, config) => {
  return api.post(`${API_URL}/file`, formData, config).then((result) => {
    return result.data;
  });
};

export { uploadImage };
